import React, { useState } from 'react';
import { ReactComponent as InfoIcon } from 'src/Images/icons/common/info.svg';
import CustomMultiSelect from 'src/utils/CustomMultiSelect';

export default function CustomCreatableSelect({
  value,
  options,
  onChange,
  onSearch,
  onMenuOpen,
  themeColor,
  ...props
}) {
  const [inputValue, setInputValue] = useState('');

  const trimmedInputValue = inputValue.trim();

  const matchingExistingOption = options.find(
    (option) => option.label.toLowerCase() === trimmedInputValue.toLowerCase(),
  );

  let displayOptions = options;
  if (trimmedInputValue && !matchingExistingOption) {
    displayOptions = [
      ...options,
      {
        value: trimmedInputValue,
        label: trimmedInputValue,
        manualEntry: true,
      },
    ];
  }

  // Display manual entries as 'Use "text" +' in the dropdown.
  // Existing options display their original labels.
  const renderOptionLabel = (option, { context }) =>
    option.manualEntry && context === 'menu' ? (
      <span className={`theme-text-color-${themeColor}`}>
        Use &ldquo;{option.label}&rdquo; +
      </span>
    ) : (
      option.label
    );

  // Return the selected label and its ID.
  // Manual entries return null as they don't have an existing record ID.
  const handleSelectChange = (selectedOption) => {
    if (!selectedOption) {
      onChange('', null);
      return;
    }

    onChange(
      selectedOption.label,
      selectedOption.manualEntry ? null : selectedOption.value,
    );
  };

  const handleInputChange = (newInputValue, { action }) => {
    // Only trigger search when the user types, not when React Select
    // clears the input on blur, selection, or menu close.
    setInputValue(newInputValue);

    if (action === 'input-change') {
      onSearch?.(newInputValue);
    }
  };

  const handleBlur = () => {
    if (!trimmedInputValue || trimmedInputValue === value) return;

    // Use the existing record if the input matches; otherwise create a manual entry.
    onChange(
      matchingExistingOption?.label ?? trimmedInputValue,
      matchingExistingOption?.value ?? null,
    );
  };

  return (
    <CustomMultiSelect
      isMulti={false}
      options={displayOptions}
      value={value ? { value, label: value } : null}
      inputValue={inputValue}
      onChange={handleSelectChange}
      formatOptionLabel={renderOptionLabel}
      onInputChange={handleInputChange}
      onMenuOpen={onMenuOpen}
      onBlur={handleBlur}
      noOptionsMessage={() => null}
      {...props}
    />
  );
}

export function ManualEntryHelperText({ themeColor }) {
  return (
    <div
      className={`div-flex-row div-align-center cg-5 text-sm-outfit theme-text-color-${themeColor}`}
    >
      <InfoIcon className="icon-size-sm" />
      Manually entered value.
    </div>
  );
}
